__turbopack_context__.v({
  "locate_authorized": "LocateAuthorized-module-scss-module__MuzB4a__locate_authorized",
  "locate_authorized__headline": "LocateAuthorized-module-scss-module__MuzB4a__locate_authorized__headline",
  "locate_authorized__illustration": "LocateAuthorized-module-scss-module__MuzB4a__locate_authorized__illustration",
  "locate_authorized__text": "LocateAuthorized-module-scss-module__MuzB4a__locate_authorized__text",
});
